export function initializeDialogs() {
  // Wire up data-confirm-delete attributes
  document.querySelectorAll<HTMLElement>('[data-confirm-delete]').forEach(el => {
    const modalSelector = el.dataset.confirmDelete;
    if (!modalSelector) return;

    el.addEventListener('click', (evt: Event) => {
      evt.preventDefault();

      const dialog = document.querySelector<HTMLDialogElement>(modalSelector);
      if (dialog) {
        dialog.showModal();
      } else {
        console.warn(`Dialog not found for selector: ${modalSelector}`);
      }
    });
  });
}
